import React, { useEffect, useState } from "react";
import { Button, Breadcrumb, Card, CardBody, CardHeader, Col, Container, Form, Row, Stack } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Select from 'react-select';

import PubSub from "pubsub-js";
import moment from "moment";

import { regExPattern } from "../../utils/regExPattern";
import { titles } from "../../constants/CONSTANT";
import { validationMessages } from "../../utils/messages";
import { ROUTES } from "../../constants/webRouting";
import solisPowerApi from "../../api/solisPowerApi";
import CityState from "../../constants/CityState.json";
import { getUserDetails } from "../../utils/helper";
import { handleUppercaseChange } from "../common/UpperCaseMethod";
import initialValues from "../../utils/InitialValues";
import initialErrors from "../../utils/initialErrors";
import useFormErrors from "../../hooks/useFormErrors";
import useValidationMessage from "../../hooks/useValidationMessage";
const userInfo = getUserDetails();
const states = [...(new Set(CityState.map((item) => item.state)))];

const ContactEdit = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // contact state
  const [contact, setContact] = useState(location.state ? location.state : initialValues.contact);
  const { errors, setError, clearError, validateField, validateFields, hasErrors, setErrors } = useFormErrors(initialErrors().contact);
  const { getMessage } = useValidationMessage();
  // validation state
  const [validated, setValidated] = useState(false);

  const handleChange = (e) => {
    console.log("handleChange")
    const { name, value } = e.target;
    setContact({ ...contact, [name]: value });
    validateField(
      name,
      value,
      fieldConfigurations.find((item) => item.name == name)?.pattern,
      fieldConfigurations.find((item) => item.name == name)?.required,
      getMessage(name, 'required') || "Required",
      getMessage(name, 'invalid') || "Invalid value");
    setValidated(true);
  };

  useEffect(() => {
    console.log("check error == ", errors)
    console.log("check errors?.location_link?.message == ", errors?.location_link?.message)
  }, [errors]);

  const fieldConfigurations = [
    {
      name: "firstname",
      label: "Contact Name",
      type: "text",
      placeholder: "Enter Contact name",
      required: true,
      pattern: regExPattern.name,
    },
    // {
    //   name: "lastname",
    //   label: "Last Name",
    //   type: "text",
    //   placeholder: "Enter last name",
    //   // required: true,
    //   pattern:regExPattern.name,

    // },
    {
      name: "salutation",
      label: "Salutation",
      type: "select",
      options: [
        { value: "Mr.", label: "Mr." },
        { value: "Mrs.", label: "Mrs." },
        { value: "Ms.", label: "Ms." },
        { value: "Dr.", label: "Dr." },
        { value: "Prof.", label: "Prof." }
      ],
    },
    {
      name: "title",
      label: "Title",
      type: "select",
      options: titles
    },
    {
      name: "street",
      label: "Street",
      type: "text",
      placeholder: "Enter street address",
    },
    {
      name: "city",
      label: "City",
      type: "text",
      placeholder: "Enter city",
    },
    {
      name: "state",
      label: "State",
      type: "select",
    },
    {
      name: "country",
      label: "Country",
      type: "text",
      placeholder: "Enter country",
    },
    {
      name: "pincode",
      label: "Pincode",
      type: "text",
      placeholder: "Enter postal code",
    },
    {
      name: "phone",
      label: "Phone",
      type: "tel",
      placeholder: "Enter phone number",
      pattern: regExPattern.name,
    },
    {
      name: "email",
      label: "Email",
      type: "email",
      placeholder: "Enter email",
      pattern: regExPattern.email,
    },
    {
      name: "whatsapp_no",
      label: "WhatsApp Number",
      type: "text",
      placeholder: "Enter WhatsApp number",
      pattern: regExPattern.phone,
    },
    {
      name: "date_of_birth",
      label: "Date of Birth",
      type: "date",
      placeholder: "Enter Date of Birth",
    },
    {
      name: "reference",
      label: "Reference",
      type: "text",
      placeholder: "Enter reference details",
    },
    {
      name: "referredby",
      label: "Referred By",
      type: "uuid",
      placeholder: "Select referring user ID",
      relation: "users", // you can link to another entity
    },
    {
      name: "accountid",
      label: "Account",
      type: "select",
    },
    {
      name: "location_link",
      label: "Location Link",
      type: "text",
      placeholder: "Paste Google Maps link",
      pattern: regExPattern.locationUrl,
    },
  ];
  // Handle City & state values
  // const [states, setStates] = useState([...(new Set(CityState.map((item) => item.state)))]);
  const [cities, setCities] = useState(null);

  // If state value changed set the cities according to state
  useEffect(() => {
    setCities([...(new Set(CityState.filter((item) => item.state == contact?.state).map((item) => item.name)))]);
  }, [contact?.state]);

  // accounts
  const [accounts, setAccounts] = useState([]);

  // contacts(references)
  const [contacts, setContacts] = useState([]);

  useEffect(() => {
    // async function fetchContacts(){
    //   const fetchedContacts = await solisPowerApi.fetchContactById();
    //   console.log('fetchedContacts',fetchedContacts);
    //   Array.isArray(fetchedContacts) && setContacts(fetchedContacts?.map((fetchedContact)=>({id:fetchedContact?.id,name:`${fetchedContact?.firstname || ""} ${fetchedContact?.lastname || ""}`})));
    // }
    async function fetchAccounts() {
      const fetchAccountsRecords = await solisPowerApi.fetchAccounts();
      console.log('fetchAccountsRecords', fetchAccountsRecords);
      Array.isArray(fetchAccountsRecords) && setAccounts(fetchAccountsRecords?.map((fetchAcc) => ({ id: fetchAcc?.id, name: `${fetchAcc?.name || ""} ` })));
    }
    function init() {
      // fetchContacts();
      fetchAccounts();
    }
    init();
  }, []);

  // onSubmit handler 
  const handleSubmit = async (e) => {
    const { name, value } = e.target;
    console.log('before delete contact', contact);
    e.preventDefault();
    // console.log('errors', errors);

    if (name === "date_of_birth") {
      const age = moment().diff(moment(value), "years");
      if (age < 18) {
        setError("date_of_birth", {
          message: "Age must be 18 years or above",
        });
        return;
      } else {
        clearError("date_of_birth");
      }
    }

    //Delete Account Name Beacause Its not Exist in Db.
    hasErrors();
    const fieldsToValidate = Object.keys(contact).map((key) => ({
      name: key,
      value: contact[key],
      pattern: fieldConfigurations.find((item) => item.name == key)?.pattern,
      isRequired: fieldConfigurations.find((item) => item.name == key)?.required,
      requiredMsg: getMessage(key, 'required') || 'Required',
      invalidMsg: getMessage(key, 'invalid') || 'Invalid',
    }));

    const hasError = validateFields(fieldsToValidate);

    if (hasError) {
      setValidated(true);
      return;
    }

    const record = { ...contact };
    //delete unnecessary fields.
    delete record.name;
    delete record.account_name;
    // handle date format 
    if (record?.date_of_birth) {
      record.date_of_birth = moment(record.date_of_birth).format("DD MMM, yyyy");
    }

    if (!record?.referredby) {
      record.referredby = null;
    }
    if (!record?.accountid) {
      record.accountid = null;
    }
    if (!record?.date_of_birth) {
      record.date_of_birth = null;
    }


    // //========= Logic to perform Create or Edit ======
    if (record.id) {
      // console.log('Updated');
      const result = await solisPowerApi.saveContact(record);
      if (result?.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Update",
          message: "Record updated successfully",
        });
        navigate(`/contacts/${record?.id}`, { state: record });
        navigate(`${ROUTES.CONTACT.LIST}/${record?.id}`, { state: record });
      } else {
        PubSub.publish('RECORD_ERROR_TOAST', { title: 'Record Update Error', message: result?.errors });
      }
    } else {
      // console.log('Created');
      const result = await solisPowerApi.createContact(record);
      if (result?.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record created",
          message: "Record created successfully",
        });
        navigate(`${ROUTES.CONTACT.LIST}/${result.id}`, { state: result.data });
      } else {
        PubSub.publish('RECORD_ERROR_TOAST', { title: 'Record Save Error', message: result?.errors });
      }
    }
  };

  const handleCancel = () => {
    if (contact.id) {
      navigate(`${ROUTES.CONTACT.LIST}/${contact.id}`, { state: contact });
    } else {
      navigate(ROUTES.CONTACT.LIST);
    }
  };

  const maxDOB = moment().subtract(18, "years").format("YYYY-MM-DD");

  return (
    <Container className="pb-5">
      <Row>
        <Col md={12} className="sticky-breadcrumb">
          <Breadcrumb>
            <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item onClick={() => navigate(ROUTES.CONTACT.LIST)}>
              Contacts
            </Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col md={12}>
          <Form
            className=""
            onSubmit={handleSubmit}
            noValidate
            validated={validated}
          >
            <Card className="shadow">
              <CardHeader className="bg-custom text-white sticky-card-header">
                <Row className="w-100">
                  <Col xs={12} sm={12} md={6} lg={6} className="">
                    <div className="d-flex align-items-center h-100 gap-3">
                      {contact?.id ? (
                        <h5 className="m-0">
                          Edit Contact {contact?.firstname || ""}
                        </h5>
                      ) : (
                        <h5 className="m-0">Create Contact</h5>
                      )}
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={6} lg={6} className="p-0">
                    <Stack
                      direction="horizontal"
                      className="float-end float-md-end"
                      gap={2}
                    >
                      <Button
                        size="sm"
                        className="btn-save"
                        type="submit"
                      // onClick={handleSubmit}
                      >
                        Save
                      </Button>
                      <Button
                        size="sm"
                        className="btn-delete"
                        onClick={handleCancel}
                      >
                        Cancel
                      </Button>
                    </Stack>
                  </Col>
                </Row>
              </CardHeader>

              <CardBody className="">
                <Row lg={12} className="view-form ">
                  {/* <Col lg={6}>
                    <Form.Group >
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicState"
                      >
                        Account
                      </Form.Label>

                      <Select
                        placeholder="Select your account"
                        options={accounts?.map((account) => ({ 'value': account?.id, 'label': account?.name }))}
                        onChange={(e) => {
                          handleChange({ target: { name: "accountid", 'value': e?.value,label : e?.label } });
                          handleChange({ target: { name: "account_name", value: e.label } });
                        }}
                        // value={contact?.accountid ? { value: contact?.accountid || "", label: contact?.name || "" } : ""}
                        value={contact?.accountid ? { value: contact?.accountid, label: contact?.account_name } : ""}
                      ></Select>
                      <Form.Control.Feedback type="invalid">
                        {errors?.accountid?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col> */}

                  <Col lg={6} className="">
                    {/* <div className="d-flex gap-4">
                      <Form.Group className="w-25">
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicsalutation"
                        >
                          Salutation
                        </Form.Label>
                        <Form.Control
                          as="select"
                          name="salutation"
                          value={contact?.salutation || ""}
                          onChange={handleChange}
                        >
                          <option value="">---Select---</option>
                          <option value="Mr.">Mr.</option>
                          <option value="Mrs.">Mrs.</option>
                          <option value="Miss">Miss</option>
                          <option value="Ms.">Ms.</option>
                          <option value="Dr.">Dr.</option>
                          <option value="Prof.">Prof.</option>
                          <option value="Architect.">Architect.</option>
                        </Form.Control>
                      </Form.Group>
                    </div> */}
                    <Form.Group className="w-100">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicFirstName"
                      >
                        Contact Name
                      </Form.Label>
                      <Form.Control
                        required
                        pattern={regExPattern.name}
                        type="text"
                        name="firstname"
                        placeholder="Enter first name"
                        value={contact?.firstname || ""}
                        // onChange={handleChange}
                        onChange={(e) => handleUppercaseChange(e, handleChange)}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors?.firstname?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  {/* <Col lg={6}>
                    <Form.Group
                    >
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicLastName"
                      >
                        Last Name
                      </Form.Label>
                      <Form.Control
                        required
                        pattern={regExPattern.name}
                        type="text"
                        name="lastname"
                        placeholder="Enter last name"
                        value={contact?.lastname || ""}
                        // onChange={handleChange}
                        onChange={(e) => handleUppercaseChange(e, handleChange)}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors?.lastname?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col> */}

                  <Col xs={12} sm={12} md={6} lg={6}>
                    <Form.Group>
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicEmail"
                      >
                        Email
                      </Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        placeholder="Enter email"
                        value={contact?.email || ""}
                        onChange={handleChange}
                        isInvalid={!!errors?.email}
                      />

                      <Form.Control.Feedback type="invalid">
                        {errors?.email?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col xs={12} sm={12} md={6} lg={6}>
                    <Form.Group>
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicEmail"
                      >
                        Date of Birth
                      </Form.Label>
                      {/* <Form.Control
                        type="date"
                        name="date_of_birth"
                        placeholder="Select date of birth"
                        value={
                          contact?.date_of_birth
                            ? moment(contact.date_of_birth).format("YYYY-MM-DD")
                            : ""
                        }
                        onChange={handleChange}
                        max={moment(new Date()).format("YYYY-MM-DD")}
                        onKeyDown={(e) => e.preventDefault()}
                      /> */}
                      <Form.Control
                        type="date"
                        name="date_of_birth"
                        placeholder="Select date of birth"
                        value={
                          contact?.date_of_birth
                            ? moment(contact.date_of_birth).format("YYYY-MM-DD")
                            : ""
                        }
                        onChange={handleChange}
                        max={maxDOB}
                        onKeyDown={(e) => e.preventDefault()}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors?.date_of_birth?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col xs={12} sm={12} md={6} lg={6}>
                    <Form.Group>
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicPhone"
                      >
                        Mobile Number
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="phone"
                        placeholder="Enter mobile number"
                        value={contact?.phone || ""}
                        onChange={handleChange}
                        maxLength={10}
                        pattern={regExPattern.phone}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors?.phone?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col xs={12} sm={12} md={6} lg={6}>
                    <Form.Group>
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicPhone"
                      >
                        WhatsApp Number
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="whatsapp_no"
                        placeholder="Enter whatsApp number"
                        value={contact?.whatsapp_no || ""}
                        onChange={handleChange}
                        maxLength={10}
                        pattern={regExPattern.phone}
                      />

                      <Form.Control.Feedback type="invalid">
                        {errors?.whatsapp_no?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col xs={12} sm={12} md={6} lg={6}>
                    <Form.Group>
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicPhone"
                      >
                        Reference
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="reference"
                        placeholder="Enter reference"
                        value={contact?.reference || ""}
                        // onChange={handleChange}
                        onChange={(e) => handleUppercaseChange(e, handleChange)}
                        pattern={regExPattern.name}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors?.reference?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col xs={12} sm={12} md={6} lg={6}>
                    <Form.Group>
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicTitle"
                      >
                        Contact Type
                      </Form.Label>
                      <Form.Select
                        required
                        placeholder="Select contact type"
                        aria-label="Select contact type"
                        name="title"
                        value={contact?.title || ""}
                        onChange={handleChange}
                      >
                        <option value="">---Select---</option>
                        {titles.map((title, index) => (
                          <option value={title.value} key={index}>
                            {title.label}
                          </option>
                        ))}
                      </Form.Select>

                      <Form.Control.Feedback type="invalid">
                        {errors?.title?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={12} className="section-header">
                    Address Information
                  </Col>

                  <Col lg={6}>
                    <Form.Group>
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicCompany"
                      >
                        Location Link
                      </Form.Label>
                      {/* <Form.Control
                        type="text"
                        name="location_link"
                        // placeholder="Enter location link"
                        pattern={regExPattern.locationUrl}
                        value={contact?.location_link || ""}
                        // pattern={regExPattern.name}
                        placeholder= "Paste Maps link"
                        onChange={(e) => handleChange(e)}
                      /> */}
                      <Form.Control
                        type="text"
                        name="location_link"
                        pattern={regExPattern.locationUrl}
                        value={contact?.location_link || ""}
                        placeholder="Paste Maps link"
                        onChange={handleChange}
                        isInvalid={!!errors?.location_link}
                      />

                      <Form.Control.Feedback type="invalid">
                        {/* {errors?.location_link?.message} */}
                        {errors?.location_link?.message ||
                          "Please enter a valid URL"}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col xs={12} sm={12} md={6} lg={6}>
                    <Form.Group>
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicStreet"
                      >
                        Complete Address
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="street"
                        placeholder="Enter complete address"
                        value={contact?.street || ""}
                        // onChange={handleChange}
                        onChange={(e) => handleUppercaseChange(e, handleChange)}
                      />

                      <Form.Control.Feedback type="invalid">
                        {errors?.street?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col xs={12} sm={12} md={6} lg={6}>
                    <Form.Group>
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicState"
                      >
                        State
                      </Form.Label>

                      <Select
                        placeholder="Select your state"
                        options={states?.map((state) => ({
                          value: state,
                          label: state,
                        }))}
                        onChange={(e) => {
                          setContact((prev) => ({ ...prev, city: "" }));
                          handleChange({
                            target: { name: "state", value: e.value },
                          });
                        }}
                        value={
                          contact?.state
                            ? {
                              value: contact?.state || "",
                              label: contact?.state || "",
                            }
                            : ""
                        }
                      ></Select>
                      <Form.Control.Feedback type="invalid">
                        {errors?.state?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col xs={12} sm={12} md={6} lg={6}>
                    <Form.Group>
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicCity"
                      >
                        City
                      </Form.Label>
                      <Select
                        placeholder="Select your city"
                        // className={`${contact?.city ? 'custom-react-select-valid': 'custom-react-select-invalid' }`}
                        className={"custom-react-select"}
                        options={cities?.map((city) => ({
                          value: city,
                          label: city,
                        }))}
                        onChange={(e) => {
                          handleChange({
                            target: { name: "city", value: e.value },
                          });
                        }}
                        value={
                          contact?.city
                            ? {
                              value: contact?.city || "",
                              label: contact?.city || "",
                            }
                            : ""
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors?.city?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col xs={12} sm={12} md={6} lg={6}>
                    <Form.Group>
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicPin"
                      >
                        PinCode
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="pincode"
                        placeholder="Enter pincode"
                        value={contact?.pincode || ""}
                        onChange={handleChange}
                        maxLength={6}
                        pattern={regExPattern.pinCode}
                      />

                      <Form.Control.Feedback type="invalid">
                        {errors?.pincode?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col xs={12} sm={12} md={6} lg={6}>
                    <Form.Group>
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicCountry"
                      >
                        Country
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="country"
                        placeholder="Enter country"
                        value={contact?.country || ""}
                        // onChange={handleChange}
                        onChange={(e) => handleUppercaseChange(e, handleChange)}
                        pattern={regExPattern.name}
                      />

                      <Form.Control.Feedback type="invalid">
                        {errors?.country?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default ContactEdit;